import { render, staticRenderFns } from "./OnlySiloView.vue?vue&type=template&id=76348f3d&"
import script from "./OnlySiloView.vue?vue&type=script&lang=js&"
export * from "./OnlySiloView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports